
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListCollector"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListCollectorPage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alias"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"drivingQuestion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pageDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additionalGuidancePanel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additionalGuidancePanelSwitch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"drivingPositive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"drivingNegative"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"drivingPositiveDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"drivingNegativeDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"drivingQCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anotherTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anotherPageDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anotherPositive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anotherNegative"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anotherPositiveDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anotherNegativeDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anotherQCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addItemTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addItemPageDescription"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":484}};
    doc.loc.source = {"body":"fragment ListCollector on ListCollectorPage {\n  id\n  title\n  alias\n  displayName\n  listId\n  drivingQuestion\n  pageDescription\n  additionalGuidancePanel\n  additionalGuidancePanelSwitch\n  drivingPositive\n  drivingNegative\n  drivingPositiveDescription\n  drivingNegativeDescription\n  drivingQCode\n  anotherTitle\n  anotherPageDescription\n  anotherPositive\n  anotherNegative\n  anotherPositiveDescription\n  anotherNegativeDescription\n  anotherQCode\n  addItemTitle\n  addItemPageDescription\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ListCollector"] = oneQuery(doc, "ListCollector");
        
